<template>
    <div class="add-to-basket" v-if="priceIncVat">
        <div class="row" v-if="stockWarningMessage && basketProductId && !generic">
            <div class="col mt-2">
                <p :class="'stock-warning ' + stockWarningMessage.colour.toLowerCase()">
                    {{ stockWarningMessage.name }}
                </p>
            </div>
        </div>

        <div class="priceFromArea">
            <div v-if="basketProductId !== null && offerPrice > 0.00 && !isBefore(offerStartDate) && isBefore(offerEndDate)">
                <h6 class="my-0">
                    This item is on a special limited time offer until {{ getOfferEndDate(offerEndDate) }}!
                </h6>
            </div>

            <span v-if="basketProductId == null && productPromotion == null">
                <span v-if="showFrom">from</span> &pound;{{ retailPrice }}
            </span>

            <h2 class="m-0 was-price" v-if="productPromotion != null">Was from &pound;{{ priceIncVat }}</h2>
            <h1 class="mt-1" v-if="productPromotion != null">now from &pound;{{ (priceIncVat - (priceIncVat * (productPromotion.discount / 100))).toFixed(2) }}</h1>

            <h1 v-if="basketProductId != null && productPromotion == null">
                &pound;{{ priceIncVat }}
            </h1>
        </div>

        <div class="row align-items-center">
            <div class="col-8 col-md-8 col-lg-8">
                <div class="styled-dropdown variants" v-if="Object.keys(sizes).length > 0">
                    <select v-on:change="getBasketOptions" v-model="productSizeId">
                        <option value="">Please Select Size</option>
                        <option v-for="size in sizes" v-bind:key="size.id" :value="size.id">
                            {{ size.name }}
                        </option>
                    </select>
                    <i class="far fa-chevron-down"></i>
                </div>
                <div class="styled-dropdown variants" v-if="Object.keys(lengths).length > 0">
                    <select v-on:change="getBasketOptions" v-model="productLengthId"
                        :disabled="Object.keys(sizes).length > 1 && productSizeId == ''">
                        <option value="">Please Select Length</option>
                        <option v-for="length in lengths" v-bind:key="length.id" :value="length.id">
                            {{ length.name }}
                        </option>
                    </select>
                    <i class="far fa-chevron-down"></i>
                </div>
                <div class="styled-dropdown variants" v-if="Object.keys(colours).length > 1">
                    <select v-on:change="getBasketOptions" v-model="productColourId" :disabled="(Object.keys(sizes).length > 1 && productSizeId == '')
                    || (Object.keys(lengths).length > 1 && productLengthId == '')">
                        <option value="">Please Select Colour</option>
                        <option v-for="colour in colours" v-bind:key="colour.id" :value="colour.id">
                            {{ colour.name }}
                        </option>
                    </select>
                    <i class="far fa-chevron-down"></i>
                </div>
                <div class="styled-dropdown variants" v-if="Object.keys(flavours).length > 0">
                    <select v-on:change="getBasketOptions" v-model="productFlavourId" :disabled="(Object.keys(sizes).length > 1 && productSizeId == '')
                    || (Object.keys(lengths).length > 1 && productLengthId == '')
                    || (Object.keys(colours).length > 1 && productColourId == '')">
                        <option value="">Please Select Flavour</option>
                        <option v-for="flavour in flavours" v-bind:key="flavour.id" :value="flavour.id">
                            {{ flavour.name }}
                        </option>
                    </select>
                    <i class="far fa-chevron-down"></i>
                </div>
                <div class="form-group" v-if="addonProductId">
                    <label for="comment">Personalisation</label>
                    <input id="comment" type="text" class="form-control" placeholder="Enter desired text"
                        :required="addonMandatory == true" :maxlength="addonMaxInputLength" v-model="addonText" />
                    <div v-if="addonPromptMessage" class="mt-2">
                        {{ addonPromptMessage }}
                    </div>
                </div>
            </div>
            <div class="col-4 d-flex d-xl-none sizing-guide">
                <a id="sizing-btn" href="/sizing-guide" target="_blank"><i class="mdi mdi-hanger"></i> Sizing
                    Guide</a>
            </div>
            <option-suggestions-component :suggestions="suggestions" :sizes="sizes" :colours="colours"
                :lengths="lengths" :flavours="flavours" v-if="showSuggestions"></option-suggestions-component>
        </div>

        <div class="d-flex align-items-center">
            <div class="d-flex justify-content-center quantity mr-3" :disabled="loading">
                <button @click="quantity > 1 && quantity--" class="left"><i class="far fa-minus"></i></button>
                <input v-model="quantity" type="number" class="form-control text-center">
                <button @click="quantity < max && quantity++" class="right"><i class="far fa-plus"></i></button>
            </div>

            <button @click="addToBasket()" type="button" class="btn btn-primary flex-shrink-1 add-to-basket-button">Add <i
                    class="far fa-shopping-basket"></i></button>
            <div class="sizing-guide flex-grow-1 d-none d-xl-flex">
                <a id="sizing-btn" href="/sizing-guide" target="_blank"><i class="mdi mdi-hanger"></i> Sizing
                    Guide</a>
            </div>
        </div>

        <div v-if="loading" class="d-flex align-items-center justify-content-center">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>

        <div v-if="success" class="alert alert-success mt-4 mb-0">
            <span v-if="name"><strong>{{ quantity }}</strong> x <strong>{{ name }}</strong> has been added to your
                basket.</span>
            <span v-else>The product has been added to your basket.</span>
        </div>

        <div v-for="message in messages" class="mt-4 alert mb-0" :class="'alert-' + message.type"
            v-if="typeof message.global === 'undefined'">
            {{ message.content }}
        </div>

        <div v-if="usedStock" class="d-flex mt-4 align-items-center">
            <p class="mb-0 mr-4">{{ usedStock }} Pre-Loved available from £{{ usedPriceIncVat }}</p>
            <a @click="addToBasket(true)" class="btn btn-primary">Add</a>
        </div>
        <div v-if="usedStock & addonProductId">
            <p class="mt-4 font-italic">Please Note: Personalisation is not available for Pre-Loved items.</p>
        </div>
    </div>
</template>

<script>
import { EventBus } from "../../../app.js";

export default {

  data() {
    return {
      loading: false,
      quantity: 1,
      success: false,
      generic: null,
      messages: [],
      basketProductId: null,
      addonProductId: null,
      addonPromptMessage: null,
      addonMaxInputLength: null,
      addonMandatory: null,
      addonText: null,
      stockWarningMessage: null,
      sizes: [],
      lengths: [],
      colours: [],
      flavours: [],
      productSizeId: '',
      productLengthId: '',
      productColourId: '',
      productFlavourId: '',
      productPromotion: null,
      priceIncVat: null,
      retailPrice: null,
      offerPrice: null,
      offerStartDate: null,
      offerEndDate: null,
      suggestions: [],
    }
  },

    props: {
        productId: {
            type: Number,
        },
        schoolId: {
            type: Number | null,
        },
        yearGroupId: {
            type: Number | null,
        },
        min: {
            type: Number,
        },
        max: {
            type: Number,
        },
        name: {
            type: String,
        },
        showSuggestions: {
            type: Boolean,
            default: true,
        },
        showFrom: {
            type: Boolean,
            default: false,
        }
    },

    watch: {
        quantity: function (newQuantity, oldQuantity) {
            // validate quantity
            this.quantity = isNaN(this.quantity) ? 1 : this.quantity;
            this.quantity = this.quantity > this.max ? this.max : this.quantity;
            this.quantity = this.quantity < 1 ? 1 : this.quantity;
        }
    },

    mounted() {
        this.getBasketOptions();
    },

    methods: {
        isBefore(date) {
            const today = new Date();

            return date >= today.toISOString();
        },
        getOfferEndDate(date) {
            const offerEndDate = new Date(date);
            const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
            return offerEndDate.toLocaleDateString('en-GB', options);
        },
        getBasketOptions() {
            axios.post('/api/v1/product/basket-options',
                {
                    'product_id': this.productId,
                    'school_id': this.schoolId,
                    'year_group_id': this.yearGroupId,
                    'product_size_id': this.productSizeId,
                    'product_length_id': this.productLengthId,
                    'product_colour_id': this.productColourId,
                    'product_flavour_id': this.productFlavourid,
                }
            )
                .then(res => {
                    if (res.data && res.data.success) {
                        // return is_from_price and retail_price
                        this.basketProductId = res.data.product_id;
                        this.sizes = res.data.sizes;
                        this.lengths = res.data.lengths;
                        this.colours = res.data.colours;
                        this.flavours = res.data.flavours;
                        this.generic = res.data.generic;
                        this.addonProductId = res.data.addon_product_id;
                        this.addonMandatory = res.data.addon_mandatory;
                        this.addonMaxInputLength = res.data.input_max_length;
                        this.addonPromptMessage = res.data.prompt_text;
                        this.stockWarningMessage = res.data.stock_warning_level;
                        this.priceIncVat = res.data.price_inc_vat;
                        this.retailPrice = res.data.retail_price;
                        this.offerPrice = res.data.offer_price;
                        this.offerStartDate = res.data.offer_start_date;
                        this.offerEndDate = res.data.offer_end_date;
                        this.outOfStock = res.data.out_of_stock;
                        this.suggestions = res.data.suggestions;
                        this.productPromotion = res.data.is_promotion;
                        this.usedStock = res.data.used_stock;
                        this.usedPriceIncVat = res.data.used_price;
                        EventBus.$emit('dropdown-change', res.data)
                    }
                })
                .catch(error => {
                    //
                })
                .finally(res => {
                    this.loading = false;
                });
        },
        addToBasket(isUsed = false) {
            this.loading = true;

            if(isUsed && this.quantity > this.usedStock) {
                this.quantity = this.usedStock;
            }

            axios.post('/api/v1/basket/add', {
                'promotion_id': this.productPromotion?.id,
                'school_id': this.schoolId,
                'items': [{
                    'product_id': this.basketProductId,
                    'quantity': this.quantity,
                    'addon_item_comment': this.addonText,
                    'is_used': isUsed
                }]
            })
                .then(res => {
                    if (res.data && res.data.messages) {
                        this.messages = res.data.messages;
                    }

                    if (res.data && res.data.success) {
                        this.success = true;
                        this.$root.basket = res.data.basket;
                        this.$root.addedProduct = this.basketProductId;
                        this.$root.showMiniBasket = true;
                    } else {
                        this.success = false;
                    }
                })
                .catch(err => {
                    this.messages = [];
                    for (const msg in err.response.data.errors) {
                        this.messages.push(
                            {
                                type: 'danger',
                                content: err.response.data.errors[msg][0]
                            }
                        );
                    }
                    this.success = false;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>

